import { TooltipV2 } from "src/components/TooltipV2/TooltipV2.tsx";
import { InfoOutlinedIcon, Lang } from "src/lib/ui-icon-v2";
import React, { Fragment, type ReactNode } from "react";
import * as styles from "./InputLabel.styles.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const InputLabel = ({
  label,
  id,
  required,
  helperText,
  translatable,
  additionalElems,
}: {
  label: ReactNode;
  helperText?: ReactNode;
  id?: string;
  required?: boolean;
  translatable?: boolean;
  additionalElems?: ReactNode[];
}) => {
  const { t } = useTranslation(TranslationNamespaceEnum.FormComponent);
  return (
    <div css={styles.container}>
      <div>
        <label css={styles.label} htmlFor={id}>
          {label}
        </label>
        {required && <span css={styles.requiredIndicator}>*</span>}
      </div>
      {translatable && (
        <TooltipV2 cursor={"help"} content={t("translatableField")}>
          <Lang />
        </TooltipV2>
      )}

      {helperText && (
        <TooltipV2 cursor={"help"} content={helperText}>
          <InfoOutlinedIcon />
        </TooltipV2>
      )}

      <div css={styles.additionalElems}>
        {additionalElems?.map((elem, i) => <Fragment key={i}>{elem}</Fragment>)}
      </div>
    </div>
  );
};
